import { NextPage } from 'next';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import Head from 'next/head';

const Terms: NextPage = () => {
  return (
    <>
      <Head>
        <title>kliggit - Terms of Service</title>
      </Head>
      <div>
        <Header />
        <div className="px-5 md:px-[4.875rem] lg:px-[8.8125rem] xl:px-[14.375rem] mb-20">
          <h1 className="mb-4 font-bold uppercase">
            kliggit global terms of service and use for all users
          </h1>
          <main className="space-y-6">
            <p className="mb-6 font-bold">Last updated: July 14, 2021</p>
            <p>
              Welcome <br /> Welcome to the kliggit experience. Thank you for
              using the website, mobile or other applications on our platform
              and the products, services and features we provide (collectively,
              the “Site”).
            </p>
            <p>
              Our Site <br /> kliggit provides a space to discover and engage
              other users, to show and share your value and experience with your
              local community or worldwide, through kliggit TalkTimes or other
              services and features we may offer.
            </p>
            <p>
              Terms and Use <br /> PLEASE READ THESE TERMS. THIS IS A BINDING
              CONTRACT. YOUR USE OF THE SITE OR BY CLICKING “I ACCEPT” SIGNIFIES
              YOUR BINDING AGREEMENT TO THESE TERMS, INCLUDING ANY MODIFICATIONS
              BY KLIGGIT. IF YOU DO NOT AGREE TO OUR TERMS, DO NOT ACCESS OR USE
              OUR SITE.
            </p>
            <p>
              If you are under age 18 (and are otherwise permitted under Section
              2 below), you only may use the Site with the consent of your
              parent or legal guardian. Please be sure your parent or legal
              guardian has reviewed and discussed these Terms with you.
            </p>
            <p>
              LIMITATION OF RIGHTS NOTICE: Sections 17 and 18 of these Terms
              contains provisions governing how claims you and kliggit have
              against each other are resolved (including limits of our liability
              and where claims may be litigated), including any claims that
              arose or were asserted before the “Last Updated” date at the top
              of these Terms. Please read those Sections carefully.
            </p>
            <ol className="ml-[4.875rem] mb-[4.5rem] space-y-6 list-decimal list-inside">
              <li>
                <span className="font-bold">
                  Definitions In the Terms of Service or Use:
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    &quot;We&quot;, &quot;Our&quot;, &quot;Us&quot; refers to
                    kliggit.
                  </li>

                  <li>
                    &quot;kliggit&quot; refers to kliggit, Inc. and any
                    subsidiary, parent or affiliated company.
                  </li>

                  <li>
                    &quot;kliggit Party&quot; refers to kliggit parent company,
                    subsidiaries, affiliates, officers, employees, directors,
                    shareholders, agents, partners, vendors, and licensors
                    (collectively, “kliggit parties”).
                  </li>

                  <li>
                    &quot;Site&quot; refers to access to our website
                    (kliggit.com), mobile or other applications on any platform
                    (&quot;App&quot;), and services we provide through them.
                  </li>

                  <li>&quot;You&quot; means you as a user of our Site.</li>

                  <li>
                    &quot;TalkTime&quot; refers to recorded face-to-face live
                    video/audio chat through the kliggit platform (also known as
                    an &quot;Event&quot;).
                  </li>

                  <li>
                    &quot;Content&quot; means any material uploaded to our Site
                    by any User (whether a Creator or Guest), including any
                    TalkTime (and video, audio, or other recording of the
                    TalkTime), including any videos, photos, GIFs, audio files,
                    livestream material, data, text (such as comments, reviews,
                    and hashtags), metadata, images, interactive features,
                    emojis, memes, graphics, and any other.
                  </li>

                  <li>
                    &quot;Creator&quot; means a User who has registered a
                    kliggit account and creates or lists TalkTime Events or
                    other services on our site for other Users to book.
                  </li>

                  <li>
                    &quot;Guest&quot; means a registered kliggit User who
                    follows, purchases or books from, or otherwise engages with
                    a Creator and accesses our Site.
                  </li>

                  <li>
                    &quot;Purchaser&quot; is a User who purchases TalkTimes or
                    Events or other services and products on our Site.
                  </li>

                  <li>
                    &quot;Payment&quot; means any and all payments made through
                    our Site by a Guest or other User including payments for
                    TalkTimes or Video/Recordings of TalkTimes, for interaction
                    with the Creator, to procure new Content from the Creator,
                    and any tips paid by a User to the Creator.
                  </li>

                  <li>
                    &quot;Submission&quot; means any Content or data posted,
                    uploaded, or otherwise submitted to our Site, including a
                    video, idea, intellectual property, photo, email, text,
                    post, or other communication, whether relating to you, or a
                    third party.
                  </li>

                  <li>
                    &quot;Terms of Service and Use&quot; (also called
                    &quot;Agreement&quot; or &quot;Terms&quot;) means the
                    legally binding agreement between you and us which consists
                    of: (i) these Global Terms of Service and Use for all Users,
                    (ii) Terms of Use for Creators, (iii) Privacy Policy, (iv)
                    Grievance Policy, and (v) kReserve Terms of Use.
                  </li>

                  <li>
                    &quot;User&quot; means any user of our Site, whether a
                    Creator or a Guest (registered account on kliggit) or both.
                  </li>

                  <li>
                    &quot;Offering&quot; means any TalkTime or Event, access to
                    Creators, merchandise, or any service or product offered
                    through our Site.
                    <br />
                    <br />
                    LIMITATION OF RIGHTS NOTICE: Sections 17 and 18 of these
                    Terms contains provisions governing how claims you and
                    kliggit have against each other are resolved (including
                    limits of our liability and where claims may be litigated),
                    including any claims that arose or were asserted before the
                    “Last Updated” date at the top of these Terms. Please read
                    those Sections carefully.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Registration</span> To use our Site
                you must register and create a User account. You must provide a
                valid phone number and email address, being prompted to create a
                password with your email, where you will then be able to edit
                your username. Your password should be unique and must comply
                with the technical requirements of our Site. To register as a
                User:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    You must be at least 13 years old (you will be required to
                    confirm this);
                  </li>

                  <li>
                    If you are under 18, you may only use the Site with the
                    consent of your parent or legal guardian. Please be sure
                    your parent or legal guardian has reviewed and discussed
                    these Terms with you;
                  </li>

                  <li>
                    You agree not to create a Site account using a false
                    identity or providing false information;
                  </li>

                  <li>
                    You must not be barred from accessing our platform under any
                    laws which apply to you; and
                  </li>

                  <li>
                    If you are using the Site on behalf of a business or
                    organization, you represent that you have authority to act
                    on behalf of that entity, and that such entity accepts this
                    Agreement.
                  </li>

                  <li>
                    If you do not meet these requirements, you must not access
                    or use our Site.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Changes</span> We may update and
                change our Site occasionally for any reason, including changes
                to our services, for Users&apos; needs, and to improve
                performance, enhance functionality, for security or other
                issues. We will try to give you reasonable notice of major
                changes. We do not guarantee that our Site, or any Content on
                it, will always be available or accessible without interruption.
                We may suspend or restrict the availability of our Site for
                operational reasons. We may change or suspend or withdraw our
                Site from any platform at any time without notice.
              </li>
              <li>
                <span className="font-bold">
                  kliggit TalkTimes, Videos/Recordings, Other Content.
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Through our Site, you may purchase TalkTimes from Creators
                    (individuals or businesses), celebrities, athletes, actors,
                    performers, artists, influencers, and others (each, a
                    “Creator”). You may purchase a kliggit TalkTime (or Event)
                    from a Creator for you or a third party.
                  </li>

                  <li>
                    You acknowledge and agree that the Creator has sole
                    discretion to determine how, or whether, to fulfill your
                    request and the Content of the kliggit TalkTime created. We
                    reserve the right to reject any purchase or request in our
                    sole discretion.
                  </li>

                  <li>
                    kliggit TalkTime (and any recordings of them through audio
                    or video) are licensed, not sold. You are purchasing the
                    right (or license) to access the Creator and any related
                    public Video/Recording, not the actual kliggit TalkTime or
                    Video/Recording itself.
                  </li>

                  <li>
                    Subject to your payment in full, the Creator grants you the
                    limited rights described in Section 12 below.
                  </li>

                  <li>
                    You may not sell, resell, commercialize, or encumber your
                    rights in any kliggit product or service (including kliggit
                    TalkTime Video/Recordings), including creating a non
                    fungible token (“token”) from any kliggit product or service
                    except as agreed by kliggit in writing.
                  </li>

                  <li>
                    You may use a kliggit TalkTime Video/Recording only as set
                    forth in these Terms. We may terminate all or part of any
                    licenses at any time for any reason. We reserve the right to
                    remove a kliggit TalkTime Video/Recording from our Site at
                    any time for any reason without any notice to you.
                  </li>

                  <li>
                    Scheduling Intervals. Two-minute gaps are required in
                    between Events. Therefore, a User is not allowed to schedule
                    Events “back-to-back” or within one minute of each other.
                  </li>

                  <li>
                    If a TalkTime is canceled, the booked Guest will be removed
                    from the TalkTime and the TalkTime will be re-listed for
                    public availability.
                  </li>

                  <li>
                    If a TalkTime is deleted by the Creator, it is removed and
                    the Event is unavailable for purchase.
                  </li>

                  <li>
                    A snapshot is taken randomly during the TalkTime for the
                    video thumbnail, but the creator can choose both profile
                    images as an alternative thumbnail.
                  </li>

                  <li>
                    The public video is posted on both the Creator and Guest’s
                    profiles for other Users to engage with.
                  </li>

                  <li>
                    Public TalkTime Events: Uploaded to both the Creator’s and
                    Guest’s profiles for other Users to view and engage with.
                  </li>

                  <li>
                    Private TalkTime Events: Only viewable by the Creator and
                    Guest on respective profiles.
                  </li>

                  <li>
                    The TalkTime video recording and countdown will not begin
                    until the Creator has joined the Event.
                  </li>

                  <li>
                    kliggit reserves the right to refund the Guest if the
                    Creator misses any duration of the Event. To receive this
                    refund, the Guest must report the Event under the Grievance
                    Policy at
                    <a href="mailto:grievance@kliggit.com">
                      grievance@kliggit.com
                    </a>
                    .
                  </li>

                  <li>
                    Guaranteed Exposure Period. (i) All public events are
                    required to live publicly on the Creator’s profile for a
                    total of 28 calendar days from the time the video is
                    uploaded; and (ii) The creator will have the ability to
                    remove a public video from their profile after 28 days. This
                    allows the Guest and other Users to experience and engage
                    with the Content and may provide opportunities for future
                    engagement or Events.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Organization (or Business)</span>{' '}
                kliggit TalkTime and Videos/Recordings.
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Some Creators are a commercial entity, brand, or business
                    (&quot;Organization&quot;) in the United States and may
                    offer kliggit TalkTimes through our Site. Each Organization
                    kliggit TalkTime is transactional and private in nature and
                    any use or dissemination is restricted by the Creator,
                    unless agreed otherwise.
                  </li>

                  <li>
                    No other use is authorized under these Terms. To request
                    other uses (for example, use on additional websites, social
                    media accounts, or electronic communications) contact us at
                    <a href="mailto:creator@kliggit.com">creator@kliggit.com</a>
                    .
                  </li>

                  <li>
                    Business Creators may require additional terms and
                    restrictions on your use of any Business kliggit TalkTime,
                    including confidentiality and restrictions on any further
                    dissemination of any Business kliggit TalkTime and
                    Video/Recordings of them. Such terms are in addition to, and
                    not in place of, these Terms, as set forth in Section 7
                    below.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Acknowledgements.</span> You
                acknowledge and agree that:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    You will make sure that all information which you submit to
                    us is truthful, accurate and complete.
                  </li>

                  <li>
                    You will update your User information promptly when it
                    changes.
                  </li>

                  <li>
                    You have not been prohibited from using or accessing any
                    aspect of our Site by us or pursuant to any applicable law
                    or regulation.
                  </li>

                  <li>
                    You consent to receiving communications from us
                    electronically, including by emails and messages posted to
                    your kliggit account, and to the processing of your personal
                    data as more fully detailed in our Privacy Policy.
                  </li>

                  <li>
                    You will keep your account/login details confidential and
                    secure and you will not disclose these to anyone else. You
                    will contact us at{' '}
                    <a href="mailto:report@kliggit.com">report@kliggit.com</a>{' '}
                    promptly if you believe someone has used or is using your
                    account without your permission or if your account has been
                    subject to any other breach of security.
                  </li>

                  <li>
                    You are responsible for all activity on your account even
                    if, contrary to these Terms, someone else uses your account.
                  </li>
                  <li>
                    Content is the responsibility of the Creator or person or
                    entity that provides it to the Site. We are under no
                    obligation to host or provide Content. Any User may report
                    Content believed to violate any of these Terms at
                    <a href="mailto:report@kliggit.com">report@kliggit.com</a>.
                  </li>
                  <li>
                    You will comply in full with these Global Terms of Service
                    and Use for all Users, and all other parts of the Terms
                    which apply to your use of our Site.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Additional Terms.</span> Some
                products or services offered through the Site may have
                additional terms (“Additional Terms”). If Additional Terms
                apply, we will provide them to you with that product or service.
                By using that product or service, you agree to the Additional
                Terms. If the Additional Terms conflict with these Terms, these
                Terms will govern unless the Additional Terms say that some of
                these Terms are modified or don’t apply (such as licenses,
                permitted uses, and cancellations).
              </li>
              <li>
                <span className="font-bold">Fees and Payment.</span> You agree
                that:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    The fee for a kliggit TalkTime or other offering is
                    specified on the Creator’s booking page on our Site when you
                    make your purchase request. You agree to pay all amounts due
                    with the payment terms in effect when you submit your
                    purchase request, or purchase merchandise, including any
                    applicable service, transaction, or processing fees.
                  </li>

                  <li>
                    All transactions are in U.S. dollars (“USD”) unless
                    otherwise specified at point of purchase.
                  </li>

                  <li>
                    You may request a kliggit TalkTime by using a valid payment
                    card through the applicable third party payment provider
                    (for App in iOS, Apple’s in-app payment system, and for
                    other parts of our Site, the payment provider we select).
                  </li>

                  <li>
                    You must provide the third party payment provider with valid
                    payment information (Visa, MasterCard, or other issuer
                    accepted by the payment provider). You acknowledge and agree
                    that kliggit does not operate, own, or control the payment
                    provider. Your use of your payment card is governed by your
                    agreement with and the privacy policy of the payment
                    provider (including in-App purchases for iOS and Android),
                    not these Terms. You agree to immediately notify the payment
                    provider of any change in your billing address (or other
                    information) for your payment card. You may not return or
                    exchange a kliggit TalkTime and no refunds will be issued,
                    except as set forth in subsection (i).
                  </li>

                  <li>
                    If the Offering permits, you may designate an additional
                    amount as a “tip” to the Creator. You acknowledge that we
                    mandate no tip or gratuity. However, any tip is
                    non-refundable and must be at least U.S. $5.00. You agree to
                    pay any amount you authorize as a tip.
                  </li>

                  <li>
                    We reserve the right (but are under no obligation) to cancel
                    your kliggit TalkTime request if your payment method is
                    declined or you have previously been banned or removed from
                    our Site for any reason.
                  </li>

                  <li>
                    Free TalkTime. Every User will be limited to five minute
                    TalkTimes if the TalkTime is not sold at a minimum of U.S.
                    $1.00 per minute.
                  </li>

                  <li>
                    Cancellation/Partial Cancellation Policy – TalkTime. You
                    agree the following governs any cancellations:
                    <ul className="ml-[4.875rem] mt-6">
                      <li>
                        (i) For a Guest, booked events must be canceled at least
                        two calendar days (48 hours) before the scheduled event
                        or the Guest will be charged 25% of the Event fee.
                      </li>
                      <li>
                        (ii) If the Guest does not show up to the Event without
                        canceling, the Guest will be charged the full Event fee.
                      </li>
                      <li>
                        (iii) If the Guest cancels within 12 hours of the event,
                        the guest will be charged 50% of the Event fee.
                        <br />
                        <br />
                      </li>

                      <li>
                        (iv) If a Creator fails to cancel a booked Event at
                        least two calendar days (48 hours) before the scheduled
                        event the Guest will have the ability to rate and leave
                        a review of the Creator.
                      </li>
                      <li>
                        (v) If a Guest leaves early, the Creator still receives
                        the total amount of funds.
                      </li>
                      <li>
                        (vi) If a Creator leaves early, the Creator does not
                        receive any funds and the Guest is refunded the total
                        amount.
                        <br />
                        <br />
                      </li>
                      <li>Refunds. You agree that:</li>
                      <li>
                        (i) You may request a refund, under the Grievance
                        Policy, if the Creator is late or has poor connection or
                        the Creator otherwise violates these Terms.
                      </li>
                      <li>
                        (ii) We will attempt to process your request within 7-14
                        days.
                      </li>
                      <li>
                        (iii) If your request is approved, you will receive a
                        total or partial refund based on the level of violation
                        of these Terms, at our discretion.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">
                  Prohibited Conduct and Content.
                </span>{' '}
                You agree the following conduct or Content is prohibited:
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Any graphic, pornographic, or other explicit sexual content.
                  </li>

                  <li>
                    Any harassment or bullying, whether on the basis of race,
                    color, religion (creed), gender, gender expression, age,
                    national origin (ancestry), disability, marital status,
                    sexual orientation, military status, or any other reason.
                  </li>

                  <li>
                    Content that includes graphic violence, threats, hate
                    speech, or incitements to violence d. Use of the Site for
                    any purpose that is illegal or prohibited in these Terms.
                  </li>

                  <li>
                    Use any robot, spider, crawler, or other automated means or
                    interface to access the Site or extract other Users’
                    information.
                  </li>

                  <li>
                    Use or development of any third party applications that
                    interact with the Site or other User’s content or
                    information without our written consent.
                  </li>

                  <li>
                    Use that damages, disables, overburdens, or otherwise
                    impairs the Site.
                  </li>

                  <li>
                    Use of another User’s account, username, or password or to
                    request login information from another User.
                  </li>

                  <li>
                    The upload or viruses or other malicious code to the Site or
                    any use that otherwise compromises the security of the Site.
                  </li>

                  <li>
                    Access areas or features of the Site without the required
                    authorizations. k. Promote any activity that violates these
                    Terms.
                  </li>

                  <li>
                    Any Screen-recording, screenshots, or other recording of
                    private TalkTime, without the Creator’s written consent.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Our Rights.</span> We have the right
                to:{' '}
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    We can, but are not obligated to, moderate or review any
                    Content to verify compliance with these Terms and/or any
                    applicable law.
                  </li>

                  <li>
                    We may suspend access to any Content you post on our Site
                    which may not comply with the Terms or any applicable law
                    while we investigate. If we suspend access to any of your
                    Content, you may request a review of our decision by
                    contacting us at contact [
                    <a href="mailto:review@kliggit.com">review@kliggit.com</a>].
                  </li>

                  <li>
                    After investigation, we may take any action we consider
                    appropriate, including to reinstate access to the Content or
                    to permanently remove or restrict access to the Content
                    without your consent or prior notice. You agree that you
                    will at your own cost promptly provide information and
                    assist our investigation. We will not be responsible for any
                    loss suffered by you arising from the suspension of access
                    to your Content or any other steps which we take in good
                    faith to investigate your Content under this section.
                  </li>

                  <li>
                    If we suspend access to or delete any of your Content, we
                    will notify you via email or electronic message to your
                    kliggit account. We are not obligated to give you prior
                    notice of such suspension or removal.
                  </li>

                  <li>
                    We reserve the right in our sole discretion to terminate
                    your agreement with us and your access to our Site for any
                    reason.
                  </li>

                  <li>
                    We can suspend access to your User account or terminate your
                    agreement with us and your access to our Site immediately
                    and without prior notice if:
                    <ul className="ml-[4.875rem] my-6">
                      <li>
                        (i) If we think that you have or may have seriously or
                        repeatedly breached any part of the Terms or if you
                        attempt or threaten to breach any part of the Terms in a
                        way which, in our opinion, has or could have serious
                        consequences for us or another User; or
                      </li>

                      <li>
                        (ii) if you take any action that in our opinion has
                        caused or is reasonably likely to cause us to suffer a
                        financial loss or that otherwise harms our reputation.
                      </li>
                    </ul>
                  </li>
                  <li>
                    During any period when access to your User account is
                    suspended, any Guest Payments which would otherwise be due
                    during the suspension also will be suspended, and we may
                    withhold all or any part of the Creator Earnings due to you
                    but not yet paid out under Section 3 of the Terms of Use for
                    Creators.
                  </li>
                  <li>
                    Upon termination of your account, we may deal with your
                    Content in any appropriate manner under these Terms,
                    including our Privacy Policy, (including by deleting it).
                    You will have no access to your Content following
                    termination of your account.
                  </li>
                  <li>
                    We will investigate any suspected or alleged misuse, abuse,
                    or unlawful use of our Site and cooperate with law
                    enforcement agencies in any investigation.
                  </li>
                  <li>
                    We can disclose any information or records in our possession
                    or control about your use of our Site to law enforcement
                    agencies in connection with any law enforcement
                    investigation of any suspected or alleged illegal activity,
                    or in response to a court order.
                  </li>
                  <li>
                    We can change the third-party payment providers that we use.
                    We will notify you of any change and store applicable
                    details on your kliggit account.
                  </li>
                  <li>
                    Other than Content (which is owned by or licensed to
                    Creators), all rights in and to Content and its entire
                    contents, features, databases, source code and
                    functionality, are owned by us and/or our licensors. Such
                    material is protected by copyright, and may be protected by
                    trademark, trade secret, and other intellectual property
                    laws.
                  </li>
                  <li>
                    We are the sole and exclusive owners of any and all data
                    relating to your use of our Site and such data can be used
                    by us for any purpose subject to our Privacy Policy.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">
                  Limitations on our Responsibility:{' '}
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    You acknowledge and agree that your use of our Site is at
                    your own risk. We do not authorize or approve Content and
                    views expressed by Creators and Guest Users, and they do not
                    represent our views.
                  </li>

                  <li>
                    Except for those expressed in our Terms, we do not grant you
                    any rights in relation to Content.
                  </li>

                  <li>
                    All Content is created and provided by Users or third
                    parties, not by us. We are not responsible for reviewing or
                    moderating Content, though we may at our discretion. We are
                    under no obligation to monitor Content or to detect breaches
                    of these or any other Terms.
                  </li>

                  <li>
                    You agree that you have no obligation to follow any
                    suggestions, comments, reviews or instructions received from
                    another User. If you do, you do so at your own risk.
                  </li>

                  <li>
                    You acknowledge and agree that any kliggit Party will have
                    no liability for any: (i) errors, mistakes, or inaccuracies
                    of Content; (ii) personal injury, property damage, or other
                    harm resulting from your access to or use of our Site; (iii)
                    any unauthorized access to or use of our Site (or platforms
                    hosting our Site), any personal information, or user data;
                    (iv) any interruption of transmission to or from our Site;
                    (v) any viruses, trojan horses, malware, or the like that
                    may be transmitted on or through our Site; or (vi) any
                    damages, losses, costs, expenses, or liabilities of any kind
                    incurred as a result of any content posted or shared through
                    our Site.
                  </li>

                  <li>
                    The materials and Content we make accessible on our Site for
                    Users are for general information only. You acknowledge and
                    agree that when using our Site, you will be exposed to
                    Content from a variety of sources, and that we are not
                    responsible for the accuracy, usefulness, safety, legality,
                    or intellectual property rights of or relating to any such
                    content. We make no promises or guarantees about the
                    accuracy or otherwise of such materials and Content. You
                    further understand and acknowledge that you may be exposed
                    to Content that is offensive, indecent, objectionable, or
                    harassing, and you agree that you hereby waive any legal or
                    equitable rights or remedies you have or may have against
                    kliggit with respect to such Content.
                  </li>

                  <li>
                    To the fullest extent permitted by law, you acknowledge and
                    agree that in no event will any kliggit Party be liable to
                    you or to any third party for any indirect, special,
                    incidental, punitive, or consequential damages (including
                    for loss of profits, revenue, or data) or for the cost of
                    obtaining substitute products, arising out of or in
                    connection with these Terms, however caused, whether such
                    liability arises from any claim based upon contract,
                    warranty, tort (including negligence), strict liability, or
                    otherwise, and whether or not kliggit has been advised of
                    the possibility of such damages.
                  </li>

                  <li>
                    We do not promise that our Site is compatible with all
                    devices and operating systems. You are responsible for
                    configuring your technology, device, and computer programs
                    to access our Site.
                  </li>

                  <li>
                    We are not responsible for the availability of the internet,
                    or any errors in your connections, device or other
                    equipment, or software that may occur in relation to your
                    use of our Site.
                  </li>

                  <li>
                    While we try to make sure our Site is secure and free from
                    viruses, malware, or other bugs, we cannot promise that it
                    will be and have no control over the Content supplied by
                    Creators.
                  </li>

                  <li>
                    We are not responsible for any lost, stolen, or compromised
                    User accounts, passwords, email accounts, or any resulting
                    unauthorized activities or resulting unauthorized payments
                    or withdrawals of funds.
                  </li>

                  <li>
                    You acknowledge that once your Content is posted on our
                    Site, we cannot control and will not be responsible to you
                    for the use which other Users or third parties make of such
                    Content. You can delete your account at any time, but you
                    acknowledge that deleting your account will not prevent the
                    circulation of any of your Content which may have been
                    recorded by other Users in breach of the Terms or by third
                    parties prior to the deletion of your account.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">
                  Intellectual property rights – ownership and licenses:{' '}
                </span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    You acknowledge and agree that each kliggit TalkTime and
                    Video/Recording, Submission, or other offering from a
                    Creator User is owned by kliggit and/or the Creator User who
                    created it.
                  </li>

                  <li>
                    We or our licensors own all right, title, and interest in
                    and to: (i) our Site and the “look and feel” of our Site,
                    including all software, ideas, processes, data, text, media,
                    and other Content available on our Site (“kliggit Content”);
                    and (ii) our trademarks, logos, and brand elements
                    (“Marks”). Our Site, kliggit Content, and Marks are each
                    protected under U.S. and international laws.
                  </li>

                  <li>
                    You hereby grant to us a non-exclusive, royalty-free, fully
                    paid, unlimited, universal, sublicensable (through multiple
                    tiers of sublicenses), perpetual, and irrevocable license,
                    in any and all manner and media, whether now known or
                    hereinafter invented or devised (including social media
                    platforms), to use, reproduce, license, distribute, modify,
                    adapt, reformat, publicly perform, publicly display, create
                    derivative works of, and otherwise use the following for the
                    purposes of operating and providing our Site, developing and
                    improving our products and services, and advertising,
                    marketing, and promoting our Site and our products and
                    services:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i) any (video, text, or otherwise) that you make or
                        send to or create with any Creator, excluding
                        Organization Creator subject to the applicable Terms;
                      </li>

                      <li>
                        (ii) any submission that you make to kliggit, whether
                        through our Site, a social media platform, third party
                        website, or otherwise, including a video, idea,
                        intellectual property, publicity rights, review, photo,
                        video, email, text, post, or other communication,
                        whether relating to you, or a third party.
                      </li>

                      <li>
                        (iii) You represent and warrant that you either: own all
                        rights to any Submission or have all rights necessary,
                        including with respect to any third party that
                        contributed to, is included in, or is referred to, in
                        any Submission, to grant to us the foregoing rights.
                      </li>

                      <li>
                        (iv) You further agree to not make any Submission that
                        is confidential or proprietary or that contains or
                        includes any information that you do not have the right
                        to disclose or that you or any third party do not wish
                        to be disclosed. The kliggit Parties will not be
                        responsible or liable for any use or disclosure of a
                        Submission, including any personal information belonging
                        to you or a third party.
                      </li>
                    </ul>
                  </li>
                  <li>
                    We may, for any reason, refuse to accept or transmit a
                    Submission or refuse to remove a Submission from our Site.
                    Further, we reserve the right to decide whether a Submission
                    violates these Terms and may, at any time, without notice to
                    you and in our sole discretion, remove your Submission,
                    terminate your access to our Site, remove or ban you (and
                    any Site account you created or control), or take other
                    appropriate action in our sole discretion for violation of
                    these Terms.
                  </li>

                  <li>
                    A project or Offering developed by any kliggit Party may
                    seem similar to your Submission. If your Submission consists
                    of any idea, suggestion, proposal, plan, or other material
                    related to our business, you agree that you are submitting
                    that Submission at your own risk and that kliggit has no
                    obligation (including no obligation of confidentiality or
                    privacy) with respect to thatSubmission, and you grant to
                    kliggit a non-exclusive, royalty-free, fully paid,
                    unlimited, universal, sublicensable (through multiple tiers
                    of sublicenses), perpetual, and irrevocable license, in any
                    and all manner and media, whether now known or hereinafter
                    invented or devised, to reproduce, license, distribute,
                    modify, adapt, publicly perform, publicly display, create
                    derivative works of, and otherwise use and exploit in any
                    manner (including commercially), any and all Submissions,
                    unless otherwise agreed by us in writing.
                  </li>

                  <li>
                    The license which you grant to us under sub-section 12(c)
                    above is perpetual, non exclusive, worldwide, royalty-free,
                    sublicensable, assignable and transferable by us. This means
                    that the license will continue even after your agreement
                    with us ends and you stop using our Site. You agree we need
                    not pay you for the license, and that we can grant a
                    sublicense of your Content to someone else or assign or
                    transfer the license to someone else. This license allows us
                    to modify your Content, to make your Content available to
                    other Users on our Site, and to use your Content for other
                    normal operations of our Site. We will never sell your
                    Content to other platforms, though we may sell or transfer
                    any license you grant to us under these Terms if a sale of
                    our company occurs or its assets to a third party.
                  </li>

                  <li>
                    You waive all moral rights or “droit morals” that you may
                    have in any Submission or Content. You further represent and
                    warrant that no third party has any moral, “droit moral,” or
                    other rights in your Submission or Content which you may
                    have under any law to object to derogatory treatment of any
                    Submission or Content by you on our Site.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Links to and from our Site.</span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Links to our Site:
                    <ul className="ml-[4.875rem] mt-6 space-y-6 list-inside">
                      <li>
                        (i)You may link to our Site, provided you do so it is
                        fair and legal and does not damage our reputation or
                        take advantage of it, but you must not establish a link
                        in such a way as to suggest any form of association,
                        approval, or endorsement.
                      </li>

                      <li>
                        (ii) If you are a Creator, when promoting your Creator
                        account you must comply with our Terms of Service of any
                        other website where you place a link to or otherwise
                        promote your Creator account. When promoting your
                        Creator account, you must not impersonate our Site or
                        give the impression that your Creator account is being
                        promoted by us if this is not the case. You must not
                        promote your account on our Site by using Google Ads or
                        any similar advertising platform or search engine
                        advertising service.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Links from our Site: If our Site contains links to other
                    sites and resources provided by third parties, these links
                    are provided for your convenience only. Such links should
                    not be interpreted as approval by us of those linked
                    websites or information you may obtain from them. We have no
                    control over the content of those sites or resources and
                    accept no responsibility for them or for any loss or damage
                    that may arise from your use of them. If you decide to
                    access any of the third party websites linked to our Site,
                    you do so at your own risk and subject to the terms of use
                    for such sites and resources.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">How to delete your account.</span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    If you are a Guest, the deletion of your account will take
                    place within a reasonable time following your request.
                  </li>
                  <li>
                    If you are a Creator, then once you initiate the
                    &quot;delete account&quot; process your account will remain
                    open until you receive your final payment and then your
                    account will be deleted.
                  </li>
                  <li>
                    If you are both a Guest and a Creator then your account will
                    be deleted in two stages (Guest Content first and then
                    Creator).
                  </li>
                  <li>
                    You will receive an email confirmation upon the successful
                    deletion of your account. Once your account has been
                    deleted, we may deal with your Content in any appropriate
                    manner consistent with our Privacy Policy (including by
                    deleting it) and you will no longer be entitled to access
                    your Content.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Privacy.</span> Your privacy is
                important to us. Our Privacy Policy explains how we collect,
                use, and share personal information and other data. By using our
                Site, you agree to our Privacy Policy.{' '}
              </li>
              <li>
                <span className="font-bold">Indemnification.</span> You agree to
                indemnify, defend, and hold harmless kliggit and any kliggit
                Party against any claims, costs, proceedings, demands, losses,
                damages, and expenses (including reasonable attorneys’ fees and
                costs) of any kind or nature arising from, out of, in connection
                with, or relating to your: (a) violation or alleged violation of
                these Terms, or (b) use of our Site. We may select counsel for
                and control the defense of any claim you are indemnifying. You
                agree to reasonably cooperate with us in connection with any
                claim.{' '}
              </li>
              <li>
                <span className="font-bold">Limitations of Liability.</span> You
                agree that:{' '}
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Except where prohibited by applicable law, we and any
                    kliggit Party will not be liable to you for any loss of
                    profit, loss of business or revenue, business interruption,
                    loss of business opportunity, or loss of anticipated savings
                    suffered by you arising from or in connection with your use
                    of our Site.
                  </li>

                  <li>
                    Our total liability to you for any and all claims arising
                    out of or related to your Agreement with us or use of or in
                    connection with our Site, whether in contract, tort
                    (including negligence), breach of statutory duty, or
                    otherwise shall be limited to the greater of: (i) for
                    Guests, 100% of the total fees paid by you to us in
                    connection with your use of our Site in the last 12 months
                    prior to your claim; (ii) for Creators, 100% of the fees we
                    have paid to you in the last 6 months; or (iii) $500.
                  </li>

                  <li>
                    You agree that the limitations of damages set forth in these
                    Terms are fundamental elements of the bargain between
                    kliggit and you.
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-bold">Other Legal Terms.</span>
                <ul className="ml-[4.875rem] mt-6 space-y-6 list-lower-alpha list-inside">
                  <li>
                    Governing Law and Jurisdiction. This Agreement will be
                    governed by and construed the laws of the State of Oklahoma,
                    without giving effect to any conflict of laws rules or
                    provisions.
                  </li>

                  <li>
                    You and kliggit agree that any action of whatever nature
                    arising from or relating to these Terms or our Site will be
                    litigated only in the state or federal courts in Oklahoma
                    City, Oklahoma. You and kliggit consent and submit to the
                    personal jurisdiction of such courts for any such action.
                  </li>

                  <li>
                    Time to litigate a claim. YOU AND KLIGGIT AGREE THAT ANY
                    CAUSE OF ACTION ARISING OUT OF OR RELATED TO OUR SITE MUST
                    COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION
                    ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY
                    BARRED.
                  </li>
                </ul>
              </li>
            </ol>
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Terms;
